import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { STATUS } from 'domains/customer-refund/constants'

const propTypes = {
  status: PropTypes.string
}

/**
 * @param {string} status
 */
const CustomerRefundStatusBadge = ({ status }) => {

  const colorMap = {
    [STATUS.ACCEPTED] : 'info',
    [STATUS.PENDING]  : 'warning',
    [STATUS.REJECTED] : 'danger',
    [STATUS.REFUNDED] : 'success',
    [STATUS.RETURNED] : 'primary'

  }

  const color = colorMap[status] || 'default'

  return <StatusBadge color={ color } label={ status } />
}

CustomerRefundStatusBadge.propTypes = propTypes

export default CustomerRefundStatusBadge
